// Wat geen skill is (eigenaarsbesluit 14 okt 2026, besluit 4 van de globale taxonomie).
//
// EEN module voor de migratie (lib/taxonomy-global.mjs), de extensieroutes
// (lib/crm/sourcing-input.mjs) en elke schrijver (dedupeSkillsCI in lib/skills-canon.mjs).
//
// isJunkSkill is de toets op OPGESLAGEN en getypte waarden, in drie delen:
//   1. knoppen, tellers en functieregels uit de LinkedIn-sectie die
//      oudere extensiebuilds als skill meestuurden ("Alles weergeven", "12
//      onderschrijvingen", "2 ervaringen bij Rabobank", "Developer bij Kaliber"), plus
//      een los telefoonnummer.
//   2. SKILL_SCHOOL_RE: een school of opleidingsinstituut ("Hogeschool Rotterdam",
//      "University of Amsterdam", "Middelbare school"), naar het patroon uit de
//      importronde van 13 okt 2026 (docs/audits/candidate-import-2026-10-13/scripts/complete.mjs).
//   3. De vormtoets uit lib/skills-key.mjs (cleanSkill): alleen leestekens,
//      niet-Latijnse tekens, ongepaarde haakjes, langer dan 60 tekens.
//
// SKILL_JUNK_RE is strenger en geldt alleen voor wat de extensie NU van een
// LinkedIn-pagina schraapt (dezelfde regex staat in het PARSE-CORE-blok van
// extension/content/linkedin.js; lib/sourcing-ext-panel.test.mjs houdt ze gelijk). Op
// opgeslagen data raakt die regex echte skills: de dry run van 14 okt 2026 vond onder
// meer '2008 R2', '21 CFR Part 11', '8051 Assembly', '360 feedback', 'Besluitvaardigheid'
// en 'Data Management at Scale'. Daarom weegt de migratie met isJunkSkill, en de
// extensie met beide (isScrapedSkillJunk).
// Puur, zonder database.

import { isSkillJunk as isSkillShapeJunk } from './skills-key.mjs';

export const SKILL_JUNK_RE = /alles weergeven|toon alle|show all|onderschrijving|onderschreven|endorse|vaardigheid|^\d+\s|\sbij\s|\sat\s[A-Z]/i;

// Knoppen en tellers, hoofdletterongevoelig.
const SCRAPE_UI_RE = /alles weergeven|toon alle|show all|onderschrijving|onderschreven|^endorse(?:ments?)?$|^\d+\s+ervaringen?\s+bij\s/i;
// '<functie> bij <Bedrijf>': de werkgever begint met een hoofdletter of cijfer. Bewust
// hoofdlettergevoelig: 'Bemiddeling bij klachten' of 'Hulp bij financiele vragen' is
// een vaardigheid, geen functieregel.
const SCRAPE_ROLE_RE = /\sbij\s+[A-Z0-9]/;
// Een telefoonnummer: alleen cijfers, spaties en leestekens, minstens acht cijfers.
const PHONE_RE = /^\+?[\d\s().-]+$/;

// Woordgrenzen: 'Hogeschool' en 'Universiteit' zijn in het Nederlands altijd een
// instituut; in het Engels alleen 'University of', 'University &' of 'University' aan
// het eind, zodat 'University Teaching' en 'University Lecturing' blijven staan. Een
// school alleen als schooltype ('High School', 'Middelbare school'), niet in 'Apple
// School Manager' of 'Old school networking'.
export const SKILL_SCHOOL_RE = /\b(?:hogeschool|universiteit)\b|\buniversity(?:\s+of\b|\s*&|\s*$)|\b(?:high|middelbare|primary|basis)\s*school\b/i;

const isPhone = (t) => PHONE_RE.test(t) && (t.match(/\d/g) || []).length >= 8;

/** Is deze opgeslagen of getypte waarde geen skill? Leeg telt als rommel. */
export function isJunkSkill(s) {
  const t = String(s ?? '').trim();
  if (!t) return true;
  return SCRAPE_UI_RE.test(t) || SCRAPE_ROLE_RE.test(t) || isPhone(t) || SKILL_SCHOOL_RE.test(t) || isSkillShapeJunk(t);
}

/** De extensietoets: isJunkSkill plus de strengere schraapregex van linkedin.js. */
export function isScrapedSkillJunk(s) {
  const t = String(s ?? '').trim();
  return isJunkSkill(t) || SKILL_JUNK_RE.test(t);
}

/** De lijst zonder rommel, volgorde en schrijfwijze ongewijzigd. */
export function withoutJunkSkills(list) {
  return (Array.isArray(list) ? list : []).filter((s) => !isJunkSkill(s));
}
